import React from 'react';
import { BffBonusData } from '@lucky7ventures/bff-types';
import { BaseModalProps } from '@/features/modal/types';
import { BonusModalBase } from '@/features/modal/modals/BonusModalBase';

export interface WelcomeOffersModalProps {
  bonuses: BffBonusData[];
}

export const WelcomeOffersModal = ({
  closeModal,
  bonuses,
}: WelcomeOffersModalProps & Pick<BaseModalProps, 'closeModal'>) => (
  <BonusModalBase
    closeModal={closeModal}
    bonuses={bonuses}
    titleId="welcomeOffer.chooseBonus"
    showContinueWithout
  />
);
